import React from 'react';

import { FormikAsyncAutocompleteField } from '~/@components/FormikFields';
import { LocalizableText } from '~/@components/LocalizableText';
import { ICompanySearchRecord, useCompaniesSearchFunc } from '~/@store/companies';

import { useProjectFormikContext } from './ProjectEditFormik';

type Props = { disabled?: boolean };

export const ProjectEditCustomer = ({ disabled }: Props) => {
    const formik = useProjectFormikContext();

    const customersSearch = useCompaniesSearchFunc(false);

    return (
        <FormikAsyncAutocompleteField
            label={<LocalizableText code={'customer'} />}
            name={'customer'}
            formik={formik}
            renderOption={(customer: ICompanySearchRecord) => customer.name}
            loadOptions={customersSearch}
            disabled={disabled}
        />
    );
};
